<template>
    <div id="createDetail">
        <Breadcrumb></Breadcrumb>
        <div class="custom-pro-detail">
            <el-form :model="detailForm" ref="detailForm" :rules="formRules">
                <div class="pro-info-div" >
                    <el-row class="ttl">商品详情</el-row>
                    <el-row type="flex">
                        <el-col class="col-label">生产时长</el-col>
                        <el-col><span>{{detailForm.productionCycle}}</span> 天</el-col>
                    </el-row>
                    <el-row type="flex">
                        <el-col class="col-label">商品标题</el-col>
                        <el-col>
                            <el-form-item prop="title">
                                <el-input style="max-width: 300px" size="small" v-model="detailForm.title" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex">
                        <el-col class="col-label">商品视图</el-col>
                        <el-col class="pre-img-col">
                            <template v-for="imgItem in designData.samples">
                                <div class="img-content">
                                    <el-image  fit="contain" :src="imgItem" :preview-src-list="designData.samples"></el-image>
                                </div>
                            </template>
                        </el-col>
                    </el-row>
                    <el-row type="flex">
                        <el-col class="col-label">商品主图<span title="选择的素材图片"><svg-icon icon-class="tip"/></span></el-col>
                        <el-col class="pre-img-col">
                            <el-radio-group v-model="detailForm.mainPic">
                                <template v-for="imgItem in designData.images">
                                    <el-radio :label="imgItem">
                                        <div class="img-content">
                                            <el-image fit="contain" :src="imgItem.url"></el-image>
                                            <div class="check-flag">
                                                <img class="text-noSelect" src="../../../assets/images/select1.png"/>
                                            </div>
                                        </div>
                                    </el-radio>
                                </template>
                            </el-radio-group>
                        </el-col>
                    </el-row>
                    <el-row class="ttl">所有属性</el-row>
                    <el-row>
                        <div class="sku-prefix-div">
                            <el-input size="small" v-model.trim="skuPrefix" placeholder="请输入sku前缀" ></el-input><el-button size="small" @click="addSkuPrefix" type="warning" title="批量添加sku前缀">添加</el-button>
                        </div>
                        <el-table :data="detailForm.tableData" :header-cell-style="{background:'#eef1f6',color:'#595a5a'}">
                            <el-table-column label="性别" prop="gender" align="center"></el-table-column>
                            <el-table-column label="尺码" prop="size" align="center"></el-table-column>
                            <el-table-column label="颜色" prop="color" align="center"></el-table-column>
                            <el-table-column label="分销价" prop="discounted_cost" align="center"></el-table-column>
                            <el-table-column label="建议零售价" prop="recommend_price" align="center"></el-table-column>
                            <el-table-column label="重量(g)" prop="weight" align="center"></el-table-column>
                            <el-table-column label="SKU" prop="sku" align="center">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'tableData.'+ scope.$index + '.skuName'" :rules="formRules.skuName">
                                        <el-input v-model="scope.row.skuName"  size="small"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                </div>
                <div class="bottom-sticky">
                    <div class="btn-div">
                        <el-button @click="goBack">重新定制</el-button>
                        <el-button type="primary" @click="submitOk">完成定制</el-button>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
    import Breadcrumb from '@/components/common/Breadcrumb'
    import {addDesign} from '@/api/customProduct/design'
    export default {
        name: "createDetail",
        components:{Breadcrumb},
        data(){
            return{
                detailForm:{
                    title:undefined,
                    mainPic:undefined,
                    productionCycle:undefined,
                    tableData:[],
                },
                formRules:{
                    title:[{required:true,message:'商品标题不能为空',trigger: 'blur'}],
                    skuName:[{required:true,message:'商品SKU不能为空',trigger: 'blur'}]
                },
                skuPrefix:undefined,
            }
        },
        computed:{
            nginx(){
                return this.$store.state.setting.nginx
            },
            designData(){
                const data = this.$route.params && this.$route.params.hasOwnProperty('samples')?this.$route.params:JSON.parse(sessionStorage.getItem("designData"));
                this.detailForm.mainPic = data.images[0];
                this.detailForm.productionCycle = data.basic.production_cycle;
                this.detailForm.tableData = data.basic.basic_option;
                return data;
            }
        },
        mounted(){

        },
        methods:{
            //重新定制
            goBack(){
                this.$router.go(-1);
            },
            submitOk(){
                let that = this;
                this.$refs['detailForm'].validate((valid,msgObj) =>{
                    if(valid){
                        let designData = this.designData;
                        console.log(designData);
                        let dzMapIds = [];
                        designData.images.forEach(item =>{
                            dzMapIds.push(item.id);
                        });
                        let dz = {
                            basicId:designData.basic.id,
                            code:designData.basic.code,
                            dpi:designData.basic.dpi,
                            height:designData.basic.height,
                            width:designData.basic.width,
                            psd:designData.basic.psd,
                            sizeImgUrl:designData.basic.size_image,
                            mapId:dzMapIds.join(","),
                            gear:designData.selectedModelTypeId,
                            basicName:designData.basic.name,
                            name:this.detailForm.title,
                            cycle:this.detailForm.productionCycle,
                        }
                        let skuList = [];
                        designData.basic.basic_option.forEach(item =>{
                            const sku = {
                                cost:item.cost,
                                price:item.recommend_price,
                                disPrice:item.discounted_cost,
                                gender:item.gender,
                                color:item.color,
                                size:item.size,
                                weight:item.weight
                            }
                            skuList.push(sku);
                        });
                        let picList = [];
                        designData.prints.forEach(item =>{
                            const pic ={
                                picUrl:item,
                                type:'01',//01 代表打印图  02 代表效果图
                            }
                            picList.push(pic);
                        });
                        designData.samples.forEach(item =>{
                            const pic ={
                                picUrl:item,
                                type:'02',//01 代表打印图  02 代表效果图
                            }
                            picList.push(pic);
                        });
                        const data ={
                            design:dz,
                            skuList:skuList,
                            picList:picList
                        }
                        addDesign(data).then(res =>{
                            if(res.code == 200){
                                this.$router.push({path:'/carry/proCustom/design'})
                            }else{
                                this.$message.warning(res.msg)
                            }
                        }).catch(err =>{
                            console.log(err);
                        });
                        console.log(data);

                    }else{
                        let msgList = [];
                        for(let item in msgObj){
                            if(msgList.indexOf(msgObj[item][0].message) < 0){
                             msgList.push(msgObj[item][0].message);
                            }
                        }
                        this.$message.error(msgList.join("，"));
                    }
                })
            },
            //添加sku前缀
            addSkuPrefix(){
                if(this.skuPrefix == undefined || this.skuPrefix == ''){
                    this.$message.error("sku前缀不能为空");
                    return false;
                }
                let dataArr = JSON.parse(JSON.stringify(this.detailForm.tableData));
                dataArr.forEach((row,index) =>{
                    let num = index + 1;
                    // if(row.sku == undefined){
                        row.skuName = this.skuPrefix + '-' + num;
                    // }else{
                    //     row.sku = this.skuPrefix + '-' + row.sku;
                    // }
                })
                this.detailForm.tableData = dataArr;
            }
        }
    }
</script>

<style scoped>
    #createDetail{width: 100%}
</style>
